import React, { Component, useEffect, useState } from "react";
import PageSizeOptions from "../components/PageSizeOptions";
import Pagination from "../comman/pagination";
import { calculateIndex, paginate } from "../utlis/paginate";
import auth from "../services/authService";
import Moment from "react-moment";
import config from "../config.json";
import { Link, useNavigate, useLocation } from "react-router-dom";
import PurchaseOrderPopup from "./PurchaseOrderPopup";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerPerformers, loadPartnerPerformers } from "../app/store/partner";
import { getFieldData, getFormatedNumber } from "../services/appService";
import { getComponentUserStatus, getToolsCount } from "../app/store/tools";

export default function SubRecCandidates(props) {

  const { item: mainItem, workflowTask, item, module, app, appType,
    procType, parentApplication, currentTask, pType } = props;

  const [candidateList, setCandidateList] = useState([]);
  const [purchaseShowHide, setPurchaseShowHide] = useState(false);
  const [candidateObj, setCandidateObj] = useState("");
  const [type, setType] = useState("partner");
  const [poOrderType, setPoOrderType] = useState("");
  const [poCount, setPoCount] = useState(0);

  const partnerPerformerSelector = useSelector(getPartnerPerformers);
  const toolsCountSelector = useSelector(getToolsCount);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    if (item?.partnerId)
      dispatch(loadPartnerPerformers(item.partnerId));

  }, []);

  useEffect(() => {
    setCandidateList(partnerPerformerSelector);
  }, [partnerPerformerSelector])

  const handlePurchaseShowHide = (item, type) => {
    setPurchaseShowHide(!purchaseShowHide);
    setCandidateObj(item);
    setPoOrderType(type)
  };

  const handleViewInvoice = (obj) => {
    navigate("/CandidateDetails", {
      state: {
        item: obj,
        type: pType,
        from: "/ReviewTask",
        reviewTaskState: location.state,
      }
    });
  }

  const getPoCount = (obj) => {
    let poType = "recruiter";
    if (item?.partnerType === "Sub-Contractors") {
      poType = "subcontractor";
      //return getReadUnreadBgColor(50)
    }
    else {
      //return getReadUnreadBgColor(51)
    }

    let pcount = obj.poTypes.filter(x => x.type === poType && x.partnerSign !== true).length;
    if (pcount === 0) {
      pcount = obj.poTypes.filter(x => x.type === poType).length;
      return <span className="badge badge-pill badge-success position-absolute mt--2">
        {pcount}
      </span>
    } else {
      return <span className="badge badge-pill badge-danger position-absolute mt--2">
        {pcount}
      </span>
    }

  }

  const getCount = (id) => {
    const toolObj = toolsCountSelector.filter(x => x.key == id);
    if (toolObj.length > 0) return toolObj[0].value;
    return 0;
  }

  const getReadUnreadBgColor = (id) => {
    // const totalPo=getPoCount(obj);

    // if (poCount === 0) {
    //   return <span className="badge badge-pill badge-success position-absolute mt--2">
    //     {totalPo}
    //   </span>
    // }
    // else {
    //   return <span className="badge badge-pill badge-danger position-absolute mt--2">
    //     {poCount}
    //   </span>
    // }

    const compObj = componentUserStatusSelector.filter(x => x.compId === id);

    if (compObj.length > 0) {
      const unreadComps = compObj[0].unreadCompItems.split(',').sort();
      const readComps = compObj[0].compItems.split(',').sort();
      let unReadCount = 0;
      unreadComps.filter(x => x !== "").map(x => {
        const rs = readComps.filter(y => y === x);
        if (rs.length === 0) {
          unReadCount += 1;
        }
      });

      if (unReadCount === 0) {
        return <span className="badge badge-pill badge-success position-absolute mt--2">
          {getCount(id)}
        </span>
      }
      else {
        return <span className="badge badge-pill badge-danger position-absolute mt--2">
          {unReadCount}
        </span>
      }
    } else {
      return <span className="badge badge-pill badge-danger position-absolute mt--2">
        {getCount(id)}
      </span>
    }
  }
  const handleSignUnsignPo = (unSignPo) => {
    setPoCount(unSignPo);
  }

  const handleRefreshPoOrders = () => {
    if (item?.partnerId)
      dispatch(loadPartnerPerformers(item.partnerId));
  }

  const handleViewCandidateDetails = (item) => {
    navigate("/CandidateDetails", {
      state: {
        item,
        type: pType,
        from: "/ReviewTask",
        reviewTaskState: location.state,
      }
    });
  }

  const getInitial = (name) => {
    if (!name || !name.trim()) return "CN";
    const words = name.trim().split(/\s+/);
    if (words.length >= 2) return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    return name.trim().substring(0, 2).toUpperCase();
  };

  const getClientName = (performerData) => {
    return getFieldData(performerData, "projectengagement", "EndClient") ||
           getFieldData(performerData, "projectengagement", "ClientName") ||
           getFieldData(performerData, "projectengagement", "Client") ||
           "No Active Client";
  };

  return (
    <>
      <style>{`
        /* Premium Table UI/UX (matching ManageWorkflowPerformer table) */
        .wf-table-card {
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 12px !important;
          box-shadow: 0 4px 16px rgba(15, 23, 42, 0.02) !important;
          overflow: hidden !important;
          padding: 0 !important;
          margin-bottom: 20px !important;
        }

        .wf-table {
          width: 100% !important;
          border-collapse: separate !important;
          border-spacing: 0 !important;
        }

        .wf-table-scroll {
          overflow: auto !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        .wf-table-scroll::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        .wf-table-scroll::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-table-scroll::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 1px solid #f1f5f9;
        }

        .wf-thead {
          background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 2 !important;
        }

        .wf-thead th {
          font-size: 11px !important;
          font-weight: 700 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.6px !important;
          padding: 12px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important;
          white-space: nowrap !important;
        }

        .wf-table-row {
          transition: background 0.15s ease, box-shadow 0.15s ease !important;
        }

        .wf-table-row:hover {
          background: linear-gradient(90deg, rgba(37,99,235,0.03) 0%, rgba(37,99,235,0.01) 100%) !important;
        }

        .wf-table td {
          padding: 12px 16px !important;
          font-size: 13px !important;
          color: #334155 !important;
          border-bottom: 1px solid #f1f5f9 !important;
          vertical-align: top !important;
        }

        .wf-table tbody tr:last-child td {
          border-bottom: none !important;
        }

        .wf-id-cell {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 10px;
          border-radius: 999px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          font-size: 11.5px;
          font-weight: 700;
          color: #475569;
        }

        .wf-name-cell {
          display: flex;
          align-items: center;
          gap: 12px;
          min-width: 220px;
        }

        .wf-name-avatar {
          width: 36px;
          height: 36px;
          border-radius: 10px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, rgba(37,99,235,0.12), rgba(20,184,166,0.1));
          border: 1px solid rgba(37,99,235,0.16);
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 800;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .wf-name-meta {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
        }

        .wf-name-main {
          font-weight: 700;
          color: #1e293b;
          font-size: 13.5px;
        }

        .wf-name-title {
          font-size: 11.5px;
          color: #64748b;
          font-weight: 600;
        }

        .wf-data-line {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: #64748b;
          white-space: nowrap;
        }

        .wf-data-line i {
          color: #94a3b8;
          font-size: 11px;
        }

        .wf-email-line {
          max-width: 220px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .wf-empty-value {
          color: #cbd5e1;
          font-size: 11px;
          font-weight: 600;
        }

        /* ── Action Buttons ── */
        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 8px 16px !important;
          border-radius: 8px !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #475569 !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4,0,0.2,1) !important;
          outline: none !important;
        }

        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
        }

        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
        }

        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 10px -1px rgba(37,99,235,0.25) !important;
        }

        .btn-sm-custom {
          padding: 6px 12px !important;
          font-size: 12px !important;
          border-radius: 6px !important;
          gap: 6px !important;
        }

        .badge-capsule {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 20px !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          line-height: 1 !important;
        }

        .badge-capsule-modern {
          background: rgba(37, 99, 235, 0.06) !important;
          color: #2563eb !important;
          border: 1px solid rgba(37, 99, 235, 0.15) !important;
        }

        /* Empty State */
        .wf-table-empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 24px;
          text-align: center;
          background: #f8fafc;
          border-radius: 12px;
          border: 1px dashed #e2e8f0;
          color: #64748b;
        }

        .wf-empty-icon {
          font-size: 32px;
          color: #cbd5e1;
          margin-bottom: 12px;
        }

        .wf-empty-title {
          font-weight: 700;
          color: #475569;
          font-size: 14px;
          margin-bottom: 4px;
        }

        .wf-empty-desc {
          font-size: 12.5px;
          color: #94a3b8;
          max-width: 320px;
        }

        /* Time Log & Invoice Column Styling */
        .wf-timelog-card {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          padding: 8px 12px !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 10px !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.02) !important;
          width: 100% !important;
          max-width: 320px !important;
          margin-bottom: 0 !important;
        }

        .wf-timelog-card:hover {
          border-color: #bfdbfe !important;
          background: #f8fafc !important;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.05) !important;
          transform: translateY(-1px) !important;
        }

        .wf-timelog-card:hover .wf-timelog-action-btn {
          background: #2563eb !important;
          color: #ffffff !important;
        }

        .wf-timelog-card:hover .wf-timelog-action-btn i {
          transform: translateX(2px) !important;
        }

        .wf-timelog-icon-wrapper {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          border-radius: 8px !important;
          background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%) !important;
          color: #2563eb !important;
          font-size: 14px !important;
          flex-shrink: 0 !important;
          box-shadow: 0 2px 6px rgba(37, 99, 235, 0.1) !important;
        }

        .wf-timelog-card.is-invoice-card .wf-timelog-icon-wrapper {
          background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;
          color: #16a34a !important;
          box-shadow: 0 2px 6px rgba(22, 163, 74, 0.1) !important;
        }

        .wf-timelog-card.is-invoice-card:hover .wf-timelog-action-btn {
          background: #16a34a !important;
          color: #ffffff !important;
        }

        .wf-timelog-info {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          flex-grow: 1 !important;
          min-width: 0 !important;
          text-align: left !important;
        }

        .wf-timelog-title {
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #1e293b !important;
          line-height: 1.2 !important;
        }

        .wf-timelog-sub {
          font-size: 10px !important;
          color: #64748b !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          max-width: 150px !important;
        }

        .wf-timelog-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #f1f5f9 !important;
          color: #475569 !important;
          border: none !important;
          outline: none !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          padding: 5px 8px !important;
          border-radius: 6px !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          white-space: nowrap !important;
        }

        /* Candidate Column Custom Styles from ListCondidate */
        .wf-identity-cell {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          min-width: 0;
        }

        .wf-avatar-stack {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          flex-shrink: 0;
        }

        .wf-avatar-circle {
          width: 40px;
          height: 40px;
          border-radius: 12px;
          background: linear-gradient(135deg, #0f766e 0%, #2563eb 100%);
          color: #ffffff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          font-weight: 700;
          letter-spacing: 0.5px;
          flex: 0 0 auto;
          box-shadow: 0 4px 10px rgba(15, 118, 110, 0.2);
          border: 2px solid #ffffff;
          outline: 1px solid #e2e8f0;
        }

        .wf-inline-id {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 2px 6px;
          border-radius: 6px;
          font-size: 9.5px;
          font-weight: 700;
          color: #475569;
          background: #f1f5f9;
          border: 1px solid #e2e8f0;
          line-height: 1;
        }

        .wf-identity-copy {
          display: flex;
          flex-direction: column;
          gap: 3px;
          min-width: 0;
          flex: 1;
        }

        .wf-identity-heading {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
        }

        .wf-identity-title {
          color: #0f172a !important;
          font-size: 14px !important;
          font-weight: 800 !important;
          line-height: 1.3 !important;
          letter-spacing: 0.3px !important;
          text-transform: uppercase !important;
          white-space: normal !important;
          word-break: break-word !important;
          overflow-wrap: break-word !important;
        }

        .wf-identity-meta-row {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          color: #475569;
          font-size: 12px;
          line-height: 1.45;
        }

        .wf-identity-meta-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          border-radius: 5px;
          flex-shrink: 0;
          font-size: 10px;
          margin-top: 1px;
        }

        .wf-identity-meta-icon i {
          color: inherit !important;
          font-size: 10px !important;
          width: auto !important;
          text-align: center !important;
          flex-shrink: 0 !important;
        }

        .wf-icon-email {
          background: #eff6ff;
          color: #2563eb;
        }

        .wf-icon-phone {
          background: #fff7ed;
          color: #ea580c;
        }

        .wf-identity-meta-text {
          font-size: 12.5px;
          color: #475569;
        }
      `}</style>

      <div className="wf-table-card">
        <div className="table-responsive wf-table-scroll">
          <table className="table align-items-center wf-table">
            <thead className="wf-thead">
              <tr>
                <th>Candidate / ID # / IPCS ID</th>
                <th>Position & Entity Type</th>
                <th>{pType === "timelog" ? "Time Log Management" : "Invoice and Payments"}</th>
              </tr>
            </thead>
            <tbody>
              {candidateList.length === 0 ? (
                <tr>
                  <td colSpan={3} style={{ padding: 0 }}>
                    <div className="wf-table-empty" style={{ margin: 16 }}>
                      <div className="wf-empty-icon">
                        <i className="fa fa-users" aria-hidden="true" />
                      </div>
                      <p className="wf-empty-title">No Candidates Found</p>
                      <p className="wf-empty-desc">
                        There are no candidates associated with this partner record at the moment.
                      </p>
                    </div>
                  </td>
                </tr>
              ) : (
                candidateList.map((item) => (
                  <tr key={item.performerid} className="wf-table-row">
                    <td>
                      <div className="wf-identity-cell">
                        <div className="wf-avatar-stack" style={{ position: "relative" }}>
                          <div className="wf-avatar-circle">
                            {getInitial(`${item.performername} ${item.lastName || ""}`).substring(0, 2)}
                          </div>
                          <span className="wf-inline-id">
                            #{item.performerid}
                          </span>
                        </div>
                        <div className="wf-identity-copy">
                          <div className="wf-identity-heading">
                            <button
                              onClick={() => handleViewCandidateDetails(item)}
                              className="btn p-0 btn-link btn-sm text-uppercase wf-identity-title"
                              style={{ display: "inline", padding: 0, border: "none", verticalAlign: "baseline", background: "none", textAlign: "left" }}
                            >
                              {item.performername} {item.lastName}
                            </button>
                          </div>

                          {item.maxloans && (
                            <div className="wf-identity-meta-row" style={{ margin: 0 }}>
                              <span className="wf-inline-id" style={{ background: "#ecfdf5", borderColor: "#bbf7d0", color: "#047857", fontSize: "10px", fontWeight: "700" }}>
                                IPCS: #{item.maxloans}
                              </span>
                            </div>
                          )}

                          {item.performeremail && (
                            <div className="wf-identity-meta-row">
                              <div className="wf-identity-meta-icon wf-icon-email">
                                <i className="fa fa-envelope-o" />
                              </div>
                              <span className="wf-identity-meta-text">
                                {item.performeremail}
                              </span>
                            </div>
                          )}

                          {item.contactNo && (
                            <div className="wf-identity-meta-row">
                              <div className="wf-identity-meta-icon wf-icon-phone">
                                <i className="fa fa-phone" />
                              </div>
                              <span className="wf-identity-meta-text">
                                {getFormatedNumber(item.contactNo)}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px", alignItems: "flex-start" }}>
                        <span className="wf-name-title" style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>
                          {getFieldData(
                            item.performerData,
                            "projectengagement",
                            "PositionTitle"
                          ) || <span className="wf-empty-value">—</span>}
                        </span>
                        <span className="badge-capsule badge-capsule-modern">
                          {getFieldData(
                            item.performerData,
                            "candidateonboardingform",
                            "CandidateEntity"
                          ) || <span className="wf-empty-value">—</span>}
                        </span>
                      </div>
                    </td>
                    <td>
                      {pType === "timelog" ? (
                        <div
                          className="wf-timelog-card"
                          onClick={() => handleViewInvoice(item)}
                          title={`Manage time logs for ${item.performername}`}
                        >
                          <div className="wf-timelog-icon-wrapper">
                            <i className="fa fa-clock-o" />
                          </div>
                          <div className="wf-timelog-info">
                            <span className="wf-timelog-title">Time Log Hub</span>
                            <span
                              className="wf-timelog-sub"
                              title={getClientName(item.performerData)}
                            >
                              Client: {getClientName(item.performerData)}
                            </span>
                          </div>
                          <button
                            type="button"
                            className="wf-timelog-action-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewInvoice(item);
                            }}
                          >
                            Manage{" "}
                            <i
                              className="fa fa-chevron-right"
                              style={{
                                fontSize: "9px",
                                transition: "transform 0.15s ease",
                              }}
                            />
                          </button>
                        </div>
                      ) : (
                        <div
                          className="wf-timelog-card is-invoice-card"
                          onClick={() => handleViewInvoice(item)}
                          title={`Manage invoices for ${item.performername}`}
                        >
                          <div className="wf-timelog-icon-wrapper">
                            <i className="fa fa-file-text-o" />
                          </div>
                          <div className="wf-timelog-info">
                            <span className="wf-timelog-title">Invoices & Payments</span>
                            <span
                              className="wf-timelog-sub"
                              title={getClientName(item.performerData)}
                            >
                              Client: {getClientName(item.performerData)}
                            </span>
                          </div>
                          <button
                            type="button"
                            className="wf-timelog-action-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewInvoice(item);
                            }}
                          >
                            Pay Hub{" "}
                            <i
                              className="fa fa-chevron-right"
                              style={{
                                fontSize: "9px",
                                transition: "transform 0.15s ease",
                              }}
                            />
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {purchaseShowHide && (
        <PurchaseOrderPopup
          purchaseShowHide={purchaseShowHide}
          handlePurchaseShowHide={handlePurchaseShowHide}
          candidateObj={candidateObj}
          workflowTask={workflowTask}
          poOrderType={poOrderType}
          item={item}
          handleSignUnsignPo={handleSignUnsignPo}
          handleRefreshPoOrders={handleRefreshPoOrders}
        />
      )}
    </>
  );
}
